import React from 'react';
import { AddToCartActionView } from './AddToCartActionView';
import { ListInt } from '../dropdown/DropdownWithList';
import { ICartItem } from '../../interfaces/cartItem';
import { ItemIdentifier } from '../../interfaces/itemIdentifier';
import { ISupercedeProduct } from "../../../../../SignalRCartService/src/interfaces/supercedeProduct";
import { AddToCartFavorite } from './AddFavorite';
import { Observable } from 'rxjs';
import { DoNotPermitPurchase } from './DoNotPermitPurchase';

export interface AddToCartProps {
    added?: boolean,
    addNote?: boolean,
    noteComponent?: JSX.Element,
    charRemain?: number,
    dataValues: dataValues,
    permitPurchase: boolean,
    preventPurchase: boolean,
    restrictedLink: string,
    restrictedMessage: string,
    buttonClass?: string,
    quantityMessage?: string,
    buttonContent?: JSX.Element,
    addedToCart?: ICartItem[],
    supercedeItems?: ISupercedeProduct[],
    itemIdentifier?: ItemIdentifier,
    changeZIndex?: Function,
    errorMessage?: JSX.Element,
    error?: string,
    doPreventAddToCart?: boolean,
    slideInfo?: string,
    isSkuGroupSearch?: boolean,
    productCard?: boolean;
    forceInput?: boolean;
    qtyOnBlur?: (qty: any) => Observable<any>;
    isAddToCartActive?: boolean;
    inputIdentifier: string;
    inputLabel: string;
}

export interface dataValues {
    list?: Array<ListInt>,
    itemSelected?: Function,
    AddItemSelected?: Function,
    favSelected?: boolean,
    manageList?: boolean,
    setLength?: number,
    setFavorite?: Function,
    removeFavorite?: Function,
    saveNote?: Function,
    addedNoteIcon?: Function,
    charRemain?: number,
    tooltipText?: string,
    inputVal?: string
}

export const AddToCart = ({ ...props }: AddToCartProps) => {
    return (
        <div className="add-to-cart-generic d-flex justify-content-center">
            {!props.preventPurchase && props.permitPurchase ?
                <AddToCartActionView
                    list={props.dataValues.list!} setLength={props.dataValues.setLength} itemSelected={props.dataValues.itemSelected} AddItemSelected={props.dataValues.AddItemSelected}
                    favSelected={props.dataValues.favSelected!} setFavorite={props.dataValues.setFavorite} removeFavorite={props.dataValues.removeFavorite} manageList={props.dataValues.manageList} addNote={props.addNote} added={props.added}
                    charRemain={props.dataValues.charRemain} inputVal={props.dataValues.inputVal} buttonClass={props.buttonClass} buttonContent={props.buttonContent}
                    saveNote={props.dataValues.saveNote!} addedNoteIcon={props.dataValues.addedNoteIcon!} tooltipText={props.dataValues.tooltipText} addedToCart={props.addedToCart} supercedeItems={props.supercedeItems}
                    itemIdentifier={props.itemIdentifier} changeZIndex={props.changeZIndex} quantityMessage={props.quantityMessage} errorMessage={props.errorMessage} error={props.error} doPreventAddToCart={props.doPreventAddToCart} isSkuGroupSearch={props.isSkuGroupSearch} slideInfo={props.slideInfo} qtyOnBlur={props.qtyOnBlur} forceInput={props.forceInput} isAddToCartActive={props.isAddToCartActive}
                    inputIdentifier={props.inputIdentifier} inputLabel={props.inputLabel} noteComponent={props.noteComponent}
                />
                :
                props.preventPurchase ?
                    <div className="unavailable-container d-flex justify-content-center align-items-center">
                        <div className="font-weight-bold account-unavailable">
                            Not available for purchase at this time.
                        </div>
                        {(props.productCard && props.dataValues.setFavorite) &&
                            <AddToCartFavorite favSelected={props.dataValues.favSelected!} setFavorite={() => props.dataValues.setFavorite!()} />
                        }
                    </div>
                    :
                    <DoNotPermitPurchase restrictedLink={props.restrictedLink}  restrictedMessage={props.restrictedMessage}/>
            }
        </div>
    );
}